import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { updateCargoOrder } from 'actions/cargoes/orders';
import { 
    DISCHARGING_RATES_LIST, LOADING_RATES_LIST, DISCHARGING_RATES_DEFAULT,
    LOADING_RATES_DEFAULT,
} from 'constants/ldRates';
import helpers from 'helpers';

const styles = {
    selectField: { padding: '0 5px', width: '90%', fontSize: '13px' },
    menuItem: { width: 'auto', fontSize: '13px' },
};

/**
 * 
 * @param {'loading' | 'discharging'} type 
 * @param {string} key 
 */
const getLDSetting = (type, key) => {
    if (type === 'loading') {
        return LOADING_RATES_LIST.find(i => i.key === key);
    }

    return DISCHARGING_RATES_LIST.find(i => i.key === key);
};

class LDrates extends React.Component {
    constructor(props) {
        super(props);

        let loadingSettings;
        let dischargingSettings;

        if (
            this.props.cargoOrder.ldRates &&
            this.props.cargoOrder.ldRates.loading &&
            this.props.cargoOrder.ldRates.loading.type
        ) {
            loadingSettings = getLDSetting('loading', this.props.cargoOrder.ldRates.loading.type);
        } else {
            loadingSettings = LOADING_RATES_DEFAULT;
        }

        if (
            this.props.cargoOrder.ldRates &&
            this.props.cargoOrder.ldRates.discharging &&
            this.props.cargoOrder.ldRates.discharging.type
        ) {
            dischargingSettings = getLDSetting('discharging', this.props.cargoOrder.ldRates.discharging.type);
        } else {
            dischargingSettings = DISCHARGING_RATES_DEFAULT;
        }

        /**
         * @type {{ 
         *      loadingSettings: { 
         *          key: string, 
         *          value: string, 
         *          detailsDisabled?: string[],
         *          dischargingDisabled?: boolean,
         *          fill?: {
         *              field: string,
         *              value: string,
         *          }
         *      } | null, 
         *      dischargingSettings: { 
         *          key: string, 
         *          value: string, 
         *          detailsDisabled?: string[],
         *      } | null,
         *  }}
         */
        this.state = {
            loadingSettings,
            dischargingSettings,
        };

        this.selectLdRates = this.selectLdRates.bind(this);
        this.onChangeLdRatesQuantity = this.onChangeLdRatesQuantity.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (
            (
                props.cargoOrder.ldRates &&
                props.cargoOrder.ldRates.loading &&
                state.loadingSettings &&
                props.cargoOrder.ldRates.loading.type !== state.loadingSettings.key
            )
                ||
            (
                props.cargoOrder.ldRates &&
                props.cargoOrder.ldRates.discharging &&
                state.dischargingSettings &&
                props.cargoOrder.ldRates.discharging.type !== state.dischargingSettings.key
            )
        ) {
            return {
                loadingSettings: getLDSetting('loading', props.cargoOrder.ldRates.loading.type),
                dischargingSettings: getLDSetting('discharging', props.cargoOrder.ldRates.discharging.type),
            };
        }

        return null;
    }

    onChangeLdRatesQuantity(value, type) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);
        newCargoOrder.ldRates[type].quantity = value || undefined;

        if (value) {
            this.removeFromErrors(newCargoOrder, type);
        } else {
            this.addToErrors(newCargoOrder, type, 'quantity');
        }
        
        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    selectLdRates({ type, field, value }) {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);


        if (newCargoOrder.ldRates[type][field] === value) {
            newCargoOrder.ldRates[type][field] = '';
        } else {
            newCargoOrder.ldRates[type][field] = value;
        }

        if (field === 'dimension' && value) {
            this.removeFromErrors(newCargoOrder, type);
        }

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);
    }

    selectLDType = (type, value) => {
        const newCargoOrder = _.cloneDeep(this.props.cargoOrder);

        newCargoOrder.ldRates[type].type = value;

        const settings = getLDSetting(type, value);

        if (settings.detailsClear) {
            newCargoOrder.ldRates[type].dimension = undefined;
            newCargoOrder.ldRates[type].quantity = undefined;
            newCargoOrder.ldRates[type].speed = undefined;
            newCargoOrder.ldRates[type].abbreviation = undefined;
            newCargoOrder.ldRates[type].term = undefined;
        }

        if (settings.dischargingDisabled) {
            ['type', 'dimension', 'quantity', 'speed', 'abbreviation', 'term'].forEach((f) => {
                newCargoOrder.ldRates.discharging[f] = undefined;
            });
            newCargoOrder.ldRates.discharging.type = DISCHARGING_RATES_DEFAULT.key;

            const dischargingSettings = getLDSetting('discharging', DISCHARGING_RATES_DEFAULT.key);

            this.setState({ dischargingSettings });
        }

        if (settings.fill) {
            const { fill } = settings;
            newCargoOrder.ldRates.loading[fill.field] = fill.value;
        }

        if (settings.requiredFields) {
            settings.requiredFields.forEach((f) => {
                if (!newCargoOrder.ldRates[type][f]) {
                    this.addToErrors(newCargoOrder, type, f);
                } else {
                    this.removeFromErrors(newCargoOrder, type);
                }
            });
        } else {
            this.removeFromErrors(newCargoOrder, type, { force: true });
        }

        this.setState({ [`${type}Settings`]: settings });

        this.props.updateCargoOrder(this.props.numberOrderTable, newCargoOrder);

        return this.state;
    };

    addToErrors = (newCargoOrder, type, field) => {
        newCargoOrder.validateErrors.push({
            field: `ldRates.${type}.${field}`,
            messages: ['Required'],
        });
    }

    removeFromErrors = (newCargoOrder, type, { force = false } = {}) => {
        ['dimension', 'quantity', 'type'].forEach((f) => {
            if (force || newCargoOrder.ldRates[type][f]) {
                newCargoOrder.validateErrors = newCargoOrder.validateErrors.filter(e => e.field !== `ldRates.${type}.${f}`);
            }
        });
    };

    render() {
        const {
            errorLoadingQuantity, errorDischargingQuantity, errorLoadingDimension, errorDischargingDimension,
        } = this.props.errors;

        const { termEntities } = this.props;
        const { loading, discharging } = this.props.cargoOrder.ldRates;
        const { loadingSettings, dischargingSettings } = this.state;

        return (
            <div>
                <div className='row'>
                    <SelectField
                        floatingLabelText='Loading'
                        value={loading.type}
                        style={{ fontSize: '13px', width: '200px' }}
                        onChange={(_e, _i, v) => this.selectLDType('loading', v)}
                        autoWidth
                    >
                        { LOADING_RATES_LIST
                            .map((item, index) => <MenuItem key={`${item.key}_${index}`} value={item.key} primaryText={item.value} />)
                        }
                    </SelectField>
                    <TextField
                        errorText={errorLoadingQuantity}
                        style={{ fontSize: '13px', width: '58px', marginLeft: '15px' }}
                        value={loading.quantity || ''}
                        floatingLabelText='Quantity'
                        onChange={(e) => { 
                            this.onChangeLdRatesQuantity(helpers.clearLetters(e.target.value), 'loading'); 
                        }}
                        disabled={
                            loadingSettings && loadingSettings.detailsDisabled.includes('quantity')
                        }
                    />
                </div>

                <div className='row half'>
                    <div className='one-forth'>
                        <SelectField
                            floatingLabelText='Dimension'
                            style={styles.selectField}
                            value={loading.dimension}
                            onChange={(_e, _i, value) => { 
                                this.selectLdRates({ type: 'loading', field: 'dimension', value }); 
                            }}
                            maxHeight={200}
                            autoWidth
                            disabled={
                                loadingSettings && loadingSettings.detailsDisabled.includes('dimension')
                            }
                            errorText={errorLoadingDimension}
                        >
                            {termEntities.dimensions.map((d, key) => (<MenuItem
                                key={`${d}_${key}`}
                                style={styles.menuItem}
                                value={d}
                                primaryText={d}
                            />))}
                        </SelectField>
                    </div>
                    <div className='one-forth'>
                        <SelectField
                            floatingLabelText='Speed'
                            style={styles.selectField}
                            value={loading.speed}
                            onChange={(_e, _i, value) => { 
                                this.selectLdRates({ type: 'loading', field: 'speed', value }); 
                            }}
                            disabled={
                                loadingSettings && loadingSettings.detailsDisabled.includes('speed')
                            }
                            maxHeight={200}
                            autoWidth
                        >
                            {termEntities.speed.map((s, key) => (<MenuItem
                                key={`${s}_${key}`}
                                style={styles.menuItem}
                                value={s}
                                primaryText={s}
                            />))}
                        </SelectField>
                    </div>
                    <div className='one-forth'>
                        <SelectField
                            floatingLabelText='Abbreviation'
                            style={styles.selectField}
                            value={loading.abbreviation}
                            onChange={(_e, _i, value) => { 
                                this.selectLdRates({ type: 'loading', field: 'abbreviation', value }); 
                            }}
                            disabled={
                                loadingSettings && loadingSettings.detailsDisabled.includes('abbreviation')
                            }
                            maxHeight={200}
                            autoWidth
                        >
                            {termEntities.abbreviation.map((a, key) => (<MenuItem
                                key={`${a}_${key}`}
                                style={styles.menuItem}
                                value={a}
                                primaryText={a}
                            />))}
                        </SelectField>
                    </div>
                    <div className='one-forth'>
                        <SelectField
                            floatingLabelText='Term'
                            style={styles.selectField}
                            value={loading.term}
                            onChange={(_e, _i, value) => { 
                                this.selectLdRates({ type: 'loading', field: 'term', value }); 
                            }}
                            disabled={
                                loadingSettings && loadingSettings.detailsDisabled.includes('term')
                            }
                            maxHeight={200}
                            autoWidth
                        >
                            {termEntities.term.map((t, key) => (<MenuItem
                                key={`${t}_${key}`}
                                style={styles.menuItem}
                                value={t}
                                primaryText={t}
                            />))}
                        </SelectField>
                    </div>
                </div>

                <div className='row'>
                    <SelectField
                        floatingLabelText='Discharging'
                        value={discharging.type}
                        style={{ fontSize: '13px', width: '200px' }}
                        onChange={(_e, _i, v) => this.selectLDType('discharging', v)}
                        disabled={
                            (loadingSettings && loadingSettings.dischargingDisabled) ||
                            (dischargingSettings && dischargingSettings.detailsDisabled.includes('type'))
                        }
                        autoWidth
                        
                    >
                        { DISCHARGING_RATES_LIST
                            .map((item, index) => <MenuItem key={`${item.key}_${index}`} value={item.key} primaryText={item.value} />)
                        }
                    </SelectField>
                    <TextField
                        floatingLabelText='Quantity'
                        errorText={errorDischargingQuantity}
                        style={{ fontSize: '13px', width: '58px', marginLeft: '15px' }}
                        value={discharging.quantity || ''}
                        hintText='Quantity'
                        disabled={
                            (loadingSettings && loadingSettings.dischargingDisabled) ||
                            (dischargingSettings && dischargingSettings.detailsDisabled.includes('quantity'))
                        }
                        onChange={(e) => { 
                            this.onChangeLdRatesQuantity(helpers.clearLetters(e.target.value), 'discharging'); 
                        }}
                    />
                </div>

                <div className='row half' style={{ paddingBottom: '15px' }}>
                    <div className='one-forth'>
                        <SelectField
                            floatingLabelText='Dimension'
                            style={styles.selectField}
                            value={discharging.dimension || ''}
                            onChange={(_e, _i, value) => { 
                                this.selectLdRates({ type: 'discharging', field: 'dimension', value }); 
                            }}
                            disabled={
                                (loadingSettings && loadingSettings.dischargingDisabled) ||
                                (dischargingSettings && dischargingSettings.detailsDisabled.includes('dimension'))
                            }
                            maxHeight={200}
                            autoWidth
                            errorText={errorDischargingDimension}
                        >
                            {termEntities.dimensions.map((d, key) => (<MenuItem
                                key={`${d}_${key}`}
                                style={styles.menuItem}
                                value={d}
                                primaryText={d}
                            />))}
                        </SelectField>
                    </div>

                    <div className='one-forth'>
                        <SelectField
                            floatingLabelText='Speed'
                            style={styles.selectField}
                            value={discharging.speed || ''}
                            onChange={(_e, _i, value) => { 
                                this.selectLdRates({ type: 'discharging', field: 'speed', value }); 
                            }}
                            disabled={
                                (loadingSettings && loadingSettings.dischargingDisabled) ||
                                (dischargingSettings && dischargingSettings.detailsDisabled.includes('speed'))
                            }
                            maxHeight={200}
                            autoWidth
                        >
                            {termEntities.speed.map((s, key) => (<MenuItem
                                key={`${s}_${key}`}
                                style={styles.menuItem}
                                value={s}
                                primaryText={s}
                            />))}
                        </SelectField>
                    </div>

                    <div className='one-forth'>
                        <SelectField
                            floatingLabelText='Abbreviation'
                            style={styles.selectField}
                            value={discharging.abbreviation || ''}
                            onChange={(_e, _i, value) => { 
                                this.selectLdRates({ type: 'discharging', field: 'abbreviation', value }); 
                            }}
                            disabled={
                                (loadingSettings && loadingSettings.dischargingDisabled) ||
                                (dischargingSettings && dischargingSettings.detailsDisabled.includes('abbreviation'))
                            }
                            maxHeight={200}
                            autoWidth
                        >
                            {termEntities.abbreviation.map((a, key) => (<MenuItem
                                key={`${a}_${key}`}
                                style={styles.menuItem}
                                value={a}
                                primaryText={a}
                            />))}
                        </SelectField>
                    </div>

                    <div className='one-forth'>
                        <SelectField
                            floatingLabelText='Term'
                            style={styles.selectField}
                            value={discharging.term || ''}
                            onChange={(_e, _i, value) => { 
                                this.selectLdRates({ type: 'discharging', field: 'term', value }); 
                            }}
                            disabled={
                                (loadingSettings && loadingSettings.dischargingDisabled) ||
                                (dischargingSettings && dischargingSettings.detailsDisabled.includes('term'))
                            }
                            maxHeight={200}
                            autoWidth
                        >
                            {termEntities.term.map((t, key) => (<MenuItem
                                key={`${t}_${key}`}
                                style={styles.menuItem}
                                value={t}
                                primaryText={t}
                            />))}
                        </SelectField>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const errorLoading = state.cargoOrders.items[ownProps.numberOrderTable].validateErrors
            .filter(validateError => validateError.field.includes('ldRates.loading')) || [];

        const errorDischarging = state.cargoOrders.items[ownProps.numberOrderTable].validateErrors
            .filter(validateError => validateError.field.includes('ldRates.discharging')) || [];

        const errorLoadingQuantity = errorLoading
            .find(e => e.field === 'ldRates.loading.quantity');
        
        const errorDischargingQuantity = errorDischarging
            .find(e => e.field === 'ldRates.discharging.quantity');

        const errorLoadingDimension = errorLoading
            .find(e => e.field === 'ldRates.loading.dimension');

        const errorDischargingDimension = errorDischarging
            .find(e => e.field === 'ldRates.discharging.dimension');

        const errors = {
            errorLoadingQuantity: errorLoadingQuantity && errorLoadingQuantity.messages[0],
            errorDischargingQuantity: errorDischargingQuantity && errorDischargingQuantity.messages[0],
            errorLoadingDimension: errorLoadingDimension && errorLoadingDimension.messages[0],
            errorDischargingDimension: errorDischargingDimension && errorDischargingDimension.messages[0],
        };

        return {
            termEntities: state.termEntities,
            numberOrderTable: ownProps.numberOrderTable,
            cargoOrder: state.cargoOrders.items[ownProps.numberOrderTable],
            errors,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(LDrates);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/LDrates.jsx